import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  DismissPromptByTypeAction,
  LoadDismissablePromptsByTypeAction,
} from '../../domains/dismissablePromptsByType/actions.types';

import { DismissablePromptsByType } from './types';

export type DismissablePromptsAction = DismissPromptByTypeAction | LoadDismissablePromptsByTypeAction;

const initialState: DismissablePromptsByType = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<DismissablePromptsByType, DismissablePromptsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'DISMISSABLE_PROMPTS_BY_TYPE.LOAD_PENDING':
      return moveToPending(state, action.payload.promptTypes);
    case 'DISMISSABLE_PROMPTS_BY_TYPE.LOAD_REJECTED':
      return moveToRejected(state, action.payload.promptTypes, action.payload.error);
    case 'DISMISSABLE_PROMPTS_BY_TYPE.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities);
    case 'DISMISSABLE_PROMPTS_BY_TYPE.DISMISS_PROMPT_FULFILLED':
      return update(state, action.payload.promptType, { isDismissed: true });
    default:
      return state;
  }
};

export default reducer;
